module.exports = __webpack_public_path__ + "img/login_bg.2c560220.png";